import { Component, Input } from '@angular/core';
import { MarketView } from '../../../../models/markets';

@Component({
    selector: 'muni-gameday-market-ticker',
    templateUrl: './market-ticker.template.html',
    styleUrls: ['./market-ticker.styles.scss']
})
export class MarketTickerComponent {
    @Input()
    market: MarketView;
    @Input()
    showChange = true;
    @Input()
    highlightName = true;

    public get delta(): number {
        return this.market.change / this.market.price;
    }
}
